import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable, Injector } from '@angular/core';
import { Observable } from 'rxjs';
import { AuthService } from './auth.service';

@Injectable()
export class OauthInterceptor implements HttpInterceptor {

    constructor(private inj: Injector) {
    }

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

        // Skip if is request to load config
        if (req.url.endsWith('config.json')) {
            return next.handle(req);
        }

        const authService = this.inj.get(AuthService);
        const token = authService.getAuthToken();

        if (token) {
            req = req.clone({
                setHeaders: {
                    'Authorization': 'Bearer ' + token
                }
            });
        }

        return next.handle(req);
    }
}
